// extracted by mini-css-extract-plugin
export default {"icon":"icon__bYqRIz","title":"title__YEMXp9","column":"column__p86HuP"};